import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import KanbanBoard from "src/components/KanbanBoard";
import Navigator from "src/components/Navigator";
import KanbanBoardService from "src/modules/data-protection/apis/KanbanBoardService";
import {
    TasksStatuses,
    TasksPriorities,
    formatTaskAndRiskId,
} from "src/modules/data-protection/constants/Common";
import { handleAddEllipsis } from "src/utils/utils";
import FilteringComponent from "./components/FilteringComponent";

const subtitleBlockStyle = {
    fontSize: 12,
    borderLeft: "4px solid #eee",
    paddingLeft: 20,
    color: "#999",
};

const GdprKanbanBoard = () => {
    const fetchBoardData = async (filters) => {
        const service = KanbanBoardService.getInstance();
        return await service.fetchList(filters);
    };

    const getTaskLink = (data) => {
        if (data?.questionnaire === "data_subject_request") {
            return `/admin/data-protection/data-subject-request/details/${data?.reportCase?.caseId}?tab=task-management&taskId=${data?.id}`;
        }

        if (data?.questionnaire === "data_breach_incident") {
            return `/admin/data-protection/incident-register/details/${data?.reportCase?.caseId}?tab=task-management&taskId=${data?.id}`;
        }

        if (data?.questionnaire === "software") {
            return `/admin/data-protection/softwares/${data?.reportCase?.software?.id}?tab=task-management&taskId=${data?.id}`;
        }

        if (data?.questionnaire === "tom") {
            const tomId = data?.reportCase?.tom?.id ?? data?.asset_id;
            return `/admin/data-protection/toms/${tomId}/details?tab=task-management&id=${data?.id}`;
        }

        if (data?.questionnaire === "control") {
            return `/admin/data-protection/tasks/${data?.id}/details`;
        }

        if (data?.questionnaire === "other_asset") {
            return `/admin/data-protection/other-assets/${data?.reportCase?.otherAsset?.id}?tab=task-management&taskId=${data?.id}`;
        }

        if (data?.questionnaire === "general") {
            return `/admin/risk-management/task/${data?.id}/details?incomming_tab=mitigation-tasks`;
        }

        return `/admin/report/task/${data?.id}`;
    };

    const renderTaskId = (data) => {
        return `#${formatTaskAndRiskId(
            "task",
            data?.questionnaire === "software" || data?.questionnaire === "other_asset"
                ? data.asset_id
                : data?.caseSecondaryId,
            data?.risk_secondary_id ?? data?.secondaryId,
            data?.is_mitigation,
            data?.questionnaire,
            data?.task_secondary_id ?? data?.secondaryId
        )}`;
    };

    const renderSubtitle = (data, translate) => {
        if (data?.questionnaire === "data_subject_request") {
            return (
                <div className="mb-4" style={subtitleBlockStyle}>
                    <p className="mb-1">
                        {`${translate("Request ID")}: ${data?.caseSecondaryId || ""}`}
                    </p>
                </div>
            );
        }

        if (data?.questionnaire === "data_breach_incident") {
            return (
                <div className="mb-4" style={subtitleBlockStyle}>
                    <p className="mb-1">
                        {`${translate("Incident ID")}: ${data?.caseSecondaryId || ""}`}
                    </p>
                </div>
            );
        }

        if (data?.questionnaire === "software") {
            return (
                <div className="mb-4" style={subtitleBlockStyle}>
                    <p className="mb-1">
                        {`${translate("Software ID")}: ${data?.asset_id || ""}`}
                    </p>
                    <p className="mb-1">
                        {translate("Service")}:{" "}
                        {handleAddEllipsis(data.reportCase?.software?.service, 50)}
                    </p>
                </div>
            );
        }

        if (data?.questionnaire === "tom") {
            return (
                <div className="mb-4" style={subtitleBlockStyle}>
                    <p className="mb-1">
                        {`${translate("TOM ID")}: ${
                            data?.reportCase?.tom?.secondary_id ?? data?.caseSecondaryId ?? ""
                        }`}
                    </p>
                    <p className="mb-1">
                        {translate("TOM Name")}:{" "}
                        {handleAddEllipsis(data.reportCase?.tom?.name, 50)}
                    </p>
                </div>
            );
        }

        if (data?.questionnaire === "control") {
            return (
                <div className="mb-4" style={subtitleBlockStyle}>
                    <p className="mb-1">
                        {`${translate("Control ID")}: ${data.reportCase?.control?.id || ""}`}
                    </p>
                    <p className="mb-1">
                        {translate("Control Title")}:{" "}
                        {handleAddEllipsis(data.reportCase?.control?.title, 50)}
                    </p>
                </div>
            );
        }

        if (data?.questionnaire === "other_asset") {
            return (
                <div className="mb-4" style={subtitleBlockStyle}>
                    <p className="mb-1">
                        {`${translate("Other Asset ID")}: ${
                            data.reportCase?.otherAsset?.secondary_id || ""
                        }`}
                    </p>
                    <p className="mb-1">
                        {translate("Other Asset Name")}:{" "}
                        {handleAddEllipsis(data.reportCase?.otherAsset?.name, 50)}
                    </p>
                </div>
            );
        }

        if (data?.questionnaire === "general") {
            return (
                <div className="mb-4" style={subtitleBlockStyle}>
                    <p className="mb-1">
                        {`${translate("Risk ID")}: ${data.risk_secondary_id || ""}`}
                    </p>
                </div>
            );
        }

        return null;
    };

    return (
        <div className="page-content supplier-kanban-board-page">
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator
                            pageTitle="Kanban Board"
                            breadCrumbs={[
                                {
                                    title: "SIP",
                                    link: "/admin/data-protection/dashboard",
                                },
                                {
                                    title: "Kanban Board",
                                    link: "#",
                                },
                            ]}
                        />
                    </Col>
                </Row>

                <KanbanBoard
                    boardWrapperClassName="d-flex"
                    queryKey={["fetch-kanboard-tasks-list-query"]}
                    fetchBoardData={fetchBoardData}
                    statuses={TasksStatuses}
                    priorities={TasksPriorities}
                    FilteringComponent={FilteringComponent}
                    getTaskLink={getTaskLink}
                    renderTaskId={renderTaskId}
                    renderSubtitle={renderSubtitle}
                />
            </Container>
        </div>
    );
};

const mapStatetoProps = (state) => {
    const { Organization } = state;

    return {
        user: state.Login.user,
        organization: Organization,
    };
};

export default withNamespaces()(
    withRouter(
        connect(
            mapStatetoProps,
            {}
        )(GdprKanbanBoard)
    )
);
